// Generic policy renderer for Privacy / Terms / Refund / Cancellation
export default function Policy({ title, eyebrow, sections, lastUpdated }) {
  return (
    <div className="max-w-4xl mx-auto px-5 md:px-10 py-16" data-testid={`policy-${title.toLowerCase().replace(/\s+/g,"-")}`}>
      <span className="brut-tag pink">{eyebrow}</span>
      <h1 className="font-display font-black text-5xl md:text-6xl mt-3 tracking-tighter">{title}</h1>
      <p className="text-sm text-[#4A4A4A] mt-2">Last updated: {lastUpdated}</p>
      <div className="prose mt-10 space-y-8">
        {sections.map((s, i) => (
          <section key={i} className="brut-card p-6 bg-[#FDFCF8]">
            <h2 className="font-display font-black text-2xl">{s.h}</h2>
            <p className="mt-3 text-[#2a2a2a] whitespace-pre-line leading-relaxed">{s.p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
